//カード/テンプレート描画&操作
import React from 'react'
import styled from 'styled-components';
import Draggable, { DraggableData, DraggableEvent } from 'react-draggable'
import { Paper, Box } from '@material-ui/core'
import { Table, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';

import { CardTemplateDb } from '../redux/cardTemplateDbSlice';
import { ImageAttributeTemplate, CardTemplateAttributeDb } from '../redux/cardTemplateAttributeDbSlice';
import { CardTemplateImageShape, CardTemplateShapeDb } from '../redux/cardTemplateShapeDbSlice';
import { CardDb } from '../redux/cardDbSlice';
import { ImageAttribute, CardAttributeDb, CardAttributeDbHashType } from '../redux/cardAttributeDbSlice';
import { CardImageShape, CardShapeDb } from '../redux/cardShapeDbSlice';
import { FontType, FrameType } from '../redux/cardAttributeModelIndex';
import { getFontData } from '../general';
import useImageData from '../hooks/useImageData';
import CircleShape from '../card_components/CircleShape';
import RectangleShape from '../card_components/RectangleShape';
import BalloonShape from '../card_components/BalloonShape';
import { EditTemplateAttributeDbHashType, EditTemplateShapeDbHashType } from '../components/EditTemplateDialog';
import { EditCardShapeDbHashType } from '../components/EditDialog';

type CardPaperProps = {
  width: number;
  height: number;
  frameDisplay: boolean;
  frameColor: string;
  backgroundDisplay: boolean;
  backgroundColor: string;
  scaleValue: number;
}
const CardPaper = styled(Paper)<CardPaperProps>`
  position: absolute;
  width: ${props => props.width + 'px'};
  height: ${props => props.height + 'px'};
  border: ${props => props.frameDisplay ? '1px solid ' + props.frameColor : undefined};
  background-color: ${props => props.backgroundDisplay ? props.backgroundColor : '#11ffee00'};
  overflow: hidden;
  transform: ${props => 'scale(' + props.scaleValue + ')'};
  transform-origin: left top;
`
type TextDivProps = {
  x: number;
  y: number;
  width: number;
  height: number;
  rotation?: number;
  frame: FrameType;
  $backgroundColor?: string;
  selecting: boolean;
} & {[P in keyof FontType]?: FontType[P]};
const TextDiv = styled.div<TextDivProps>`
  position: absolute;
  display: grid;
  left: 0;
  top: 0;
  overflow-wrap: anywhere;
  overflow-y: hidden;
  border: ${props => {
    if (props.frame.display) return `${props.frame.thickness}px ${props.frame.color} ${props.frame.lineStyle}`;
    else return undefined;
  }};
  border-radius: ${props => {
    if (props.frame.display && props.frame.roundCorner) return `${props.frame.radius}px`;
    else return undefined;
  }};
  outline: ${props => props.selecting ? '1px blue solid' : undefined};
  box-sizing: border-box;
  background-color: ${props => props.$backgroundColor};
  transform: ${props => {
    if (props.rotation) return 'translate(' + props.x + 'px, ' + props.y + 'px) rotate(' + props.rotation + 'deg) !important';
    else return 'translate(' + props.x + 'px, ' + props.y + 'px) !important';
  }};
  transform-origin: center;
  width: ${props => props.width + 'px'};
  height: ${props => props.height + 'px'};
  font-size: ${props => props.size + 'px'};
  font-weight: ${props => props.bold ? 'bold' : 'normal'};
  color: ${props => props.color};
  font-style: ${props => props.italic ? 'italic' : 'normal'};
  text-decoration: ${props => props.underline ? 'underline' : undefined};
  font-family: ${props => props.name};
  text-align: ${props => props.yoko};
  align-items: ${props => props.tate};
  writing-mode: ${props => props.direction};
  text-orientation: ${props => props.orientation};
`
type TableDivProps = {
  width: number;
  height: number;
  selecting: boolean;
}
const TableDiv = styled.div<TableDivProps>`
  position: absolute;
  left: 0;
  top: 0;
  overflow-y: hidden;
  border: ${props => props.selecting ? '1px blue solid' : undefined};
  box-sizing: border-box;
  width: ${props => props.width + 'px'};
  height: ${props => props.height + 'px'};
`
type TableAttributeNameDivProps = {
  name?: string;
  color?: string;
  fSize?: number;
  bold?: boolean;
  italic?: boolean;
}
const TableAttributeNameDiv = styled.div<TableAttributeNameDivProps>`
  height: 15px;
  overflow: hidden;
  font-size: ${props => props.fSize + 'px'};
  font-weight: ${props => props.bold ? 'bold' : 'normal'};
  color: ${props => props.color};
  font-style: ${props => props.italic ? 'italic' : 'normal'};
  font-family: ${props => props.name};
`
type AttributeTableCellProps = {
  name?: string;
  color?: string;
  fSize?: number;
  bold?: boolean;
  italic?: boolean;
  yoko?: 'left' | 'center' | 'right';
}
const AttributeTableCell = styled(TableCell)<AttributeTableCellProps>`
  font-size: ${props => props.fSize + 'px'};
  font-weight: ${props => props.bold ? 'bold' : 'normal'};
  color: ${props => props.color};
  font-style: ${props => props.italic ? 'italic' : 'normal'};
  font-family: ${props => props.name};
  text-align: ${props => props.yoko};
`
type ImageDivProps = {
  x: number;
  y: number;
  width: number;
  height: number;
  rotation: number;
  frame: FrameType;
  $backgroundColor?: string;
  selecting: boolean;
}
const ImageDiv = styled.div<ImageDivProps>`
  position: absolute;
  transform: ${props => {
    if (props.width < 0) return 'translate(' + (props.x + props.width) + 'px, ' + props.y + 'px) rotate(' + props.rotation + 'deg) scaleX(-1) !important';
    return 'translate(' + props.x + 'px, ' + props.y + 'px) rotate(' + props.rotation + 'deg) !important';
  }};
  transform-origin: center;
  width: ${props => Math.abs(props.width) + 'px'};
  height: ${props => props.height + 'px'};
  border: ${props => {
    if (props.frame && props.frame.display) return `${props.frame.thickness}px ${props.frame.color} ${props.frame.lineStyle}`;
    else return undefined;
  }};
  border-radius: ${props => {
    if (props.frame && props.frame.display && props.frame.roundCorner) return `${props.frame.radius}px`;
    else return undefined;
  }};
  outline: ${props => props.selecting ? '1px blue solid' : undefined};
  box-sizing: border-box;
  background-color: ${props => props.$backgroundColor};
  overflow: hidden;
`
type AttributeImgProps = {
  x: number;
  y: number;
}
const AttributeImg = styled.img<AttributeImgProps>`
  position: absolute;
  left: ${props => props.x + 'px'};
  top: ${props => props.y + 'px'};
  user-select: none;
`
type ResizeBoxSvgProps = {
  x: number;
  y: number;
  rotation: number;
  imageWidth?: number;
}
const ResizeBoxSvg = styled.svg<ResizeBoxSvgProps>`
  position: absolute;
  z-index: 2;
  pointer-events: none;
  overflow: visible;
  transform-origin: center;
  transform: ${props => {
    if (typeof props.imageWidth === 'number' && props.imageWidth < 0) return 'translate(' + (props.x + props.imageWidth) + 'px, ' + props.y + 'px) rotate(' + props.rotation + 'deg)';
    else return 'translate(' + props.x + 'px, ' + props.y + 'px) rotate(' + props.rotation + 'deg)';
  }};
`
type ResizeHandleProps = {
  translateValue: {x: number, y: number};
}
const RotationHandleCircle = styled.circle<ResizeHandleProps>`
  position: absolute;
  transform: ${props => 'translate(' + props.translateValue.x + 'px, ' + props.translateValue.y + 'px) !important'};
  pointer-events: painted;
`
const ResizeHandleRect = styled.rect<ResizeHandleProps>`
  position: absolute;
  transform: ${props => 'translate(' + props.translateValue.x + 'px, ' + props.translateValue.y + 'px) !important'};
  pointer-events: painted;
`

const isAttribute = (obj: any): obj is CardTemplateAttributeDb | CardAttributeDb => {
  return typeof obj?.cardAttributeModel === 'string';
}
const isShape = (obj: any): obj is CardTemplateShapeDb | CardShapeDb => {
  return typeof obj?.kind === 'string';
}
const isImage = (obj: any): obj is ImageAttributeTemplate | ImageAttribute | CardTemplateImageShape | CardImageShape => {
  return obj?.cardAttributeModel === 'image' || obj?.kind === 'image';
}

type ResizeBoxProps = {
  id: string;
  item: CardTemplateAttributeDb | CardTemplateShapeDb | CardAttributeDb | CardShapeDb;
  scaleValue: number;
  changeItem: (item: any) => void;
}
const ResizeBox: React.FC<ResizeBoxProps> = ({id, item, scaleValue, changeItem}) => {
  const sin = (rotation: number) => {
    return rotation % 180 === 0 ? 0 : Math.sin(Math.PI * rotation / 180);
  }
  const cos = (rotation: number) => {
    return (rotation - 90) % 180 === 0 ? 0 : Math.cos(Math.PI * rotation / 180);
  }
  const getDragVerticalAngle = (x: number, y: number): number => {
    if (y === 0 && x === 0) return 0;
    if (y === 0 && x > 0) return 90;
    else if (y === 0 && x < 0) return 270;
    else if (x >= 0 && y > 0) return Math.atan(Math.abs(x) / Math.abs(y)) * 180 / Math.PI;
    else if (x >= 0 && y < 0) return 180 - Math.atan(Math.abs(x) / Math.abs(y)) * 180 / Math.PI;
    else if (x < 0 && y < 0) return Math.atan(Math.abs(x) / Math.abs(y)) * 180 / Math.PI + 180;
    else return 360 - Math.atan(Math.abs(x) / Math.abs(y)) * 180 / Math.PI;
  }
  const getDragHorizontalAngle = (x: number, y: number): number => {
    if (y === 0 && x === 0) return 0;
    if (x === 0 && y > 0) return 90;
    else if (x === 0 && y < 0) return 270;
    else if (y >= 0 && x > 0) return Math.atan(Math.abs(y) / Math.abs(x)) * 180 / Math.PI;
    else if (y >= 0 && x < 0) return 180 - Math.atan(Math.abs(y) / Math.abs(x)) * 180 / Math.PI;
    else if (y < 0 && x < 0) return Math.atan(Math.abs(y) / Math.abs(x)) * 180 / Math.PI + 180;
    else return 360 - Math.atan(Math.abs(y) / Math.abs(x)) * 180 / Math.PI;
  }
  const getHandlePosition = (item: CardTemplateAttributeDb | CardTemplateShapeDb | CardAttributeDb | CardShapeDb, spot: string): {x: number, y: number} => {
    let handleXPosition = 0;
    let handleYPosition = 0;
    if (spot === 'bottom') {
      handleXPosition = -item.height / 2 * sin(item.rotation);
      handleYPosition = item.height / 2 * cos(item.rotation);
    } else if (spot === 'right') {
      handleXPosition = item.width / 2 * cos(item.rotation);
      handleYPosition = item.width / 2 * sin(item.rotation);
    } else if (spot === 'rightBottom') {
      handleXPosition = item.width / 2 * cos(item.rotation) - item.height / 2 * sin(item.rotation);
      handleYPosition = item.height / 2 * cos(item.rotation) + item.width / 2 * sin(item.rotation);
    } else if (spot === 'leftTop') {
      handleXPosition = -item.width / 2 * cos(item.rotation) + item.height / 2 * sin(item.rotation);
      handleYPosition = -item.height / 2 * cos(item.rotation) - item.width / 2 * sin(item.rotation);
    } else if (spot === 'rightTop') {
      handleXPosition = item.width / 2 * cos(item.rotation) + item.height / 2 * sin(item.rotation);
      handleYPosition = -item.height / 2 * cos(item.rotation) + item.width / 2 * sin(item.rotation);
    } else if (spot === 'top') {
      handleXPosition = item.height / 2 * sin(item.rotation);
      handleYPosition = -item.height / 2 * cos(item.rotation);
    } else if (spot === 'left') {
      handleXPosition = -item.width / 2 * cos(item.rotation);
      handleYPosition = -item.width / 2 * sin(item.rotation);
    }
    const x = item.x + item.width / 2 + handleXPosition;
    const y = item.y + item.height / 2 + handleYPosition;
    return { x, y };
  }
  const getCursor = (item: CardTemplateAttributeDb | CardTemplateShapeDb | CardAttributeDb | CardShapeDb, spot: string): string => {
    const cursorIcons = ['ew-resize', 'nwse-resize', 'ns-resize', 'nesw-resize'];
    type ixsHashType = {[key in string]: number};
    const ixs: ixsHashType = {'right': 0, 'rightBottom': item.width > 0 ? 1 : 3, 'bottom': 2};
    const initialIx = ixs[spot];
    const increaseIx = (value: number): number => {
      return (initialIx + value) % 4;
    }
    return cursorIcons[increaseIx(Math.round(item.rotation / 45))];
  }
  const rotateItem = (data: DraggableData, item: CardTemplateAttributeDb | CardTemplateShapeDb | CardAttributeDb | CardShapeDb, id: string) => {
    const origin = getHandlePosition(item, 'leftTop');
    const drop = { x: data.x, y: data.y };
    let drag = { x: drop.x - origin.x, y: drop.y - origin.y };
    const rotateAngleBase = -drag.x * cos(item.rotation) - drag.y * sin(item.rotation);
    const rotateAngleHeight = -drag.y * cos(item.rotation) + drag.x * sin(item.rotation);
    if (item.width >= 0 && -item.width < rotateAngleBase && rotateAngleBase < 0 && -item.height < rotateAngleHeight && rotateAngleHeight < 0) return;
    if (item.width < 0 && 0 < rotateAngleBase && rotateAngleBase < -item.width && -item.height < rotateAngleHeight && rotateAngleHeight < 0) return;
    let rotateAngle = getDragHorizontalAngle(item.width / 2 + rotateAngleBase, rotateAngleHeight);
    if (item.width < 0) rotateAngle = getDragHorizontalAngle(Math.abs(item.width) / 2 - rotateAngleBase, -rotateAngleHeight);

    const newRotation = (item.rotation + rotateAngle) % 360;
    changeItem({...item, rotation: newRotation});
  }
  const resizeItemBottom = (data: DraggableData, item: CardTemplateAttributeDb | CardTemplateShapeDb | CardAttributeDb | CardShapeDb, id: string) => {
    const origin = getHandlePosition(item, 'bottom');
    const drop = { x: data.x, y: data.y };
    const drag = { x: drop.x - origin.x, y: drop.y - origin.y };
    const dragAngle = getDragVerticalAngle(-drag.x, drag.y);
    const dragValue = cos(dragAngle) === 0 ? Math.abs(drag.x / sin(dragAngle)) : Math.abs(drag.y / cos(dragAngle));
    let resize = dragValue * cos(item.rotation - dragAngle);
    if (item.height + resize < 0) resize = -item.height;

    const newAttrs = {
      x: item.x - resize / 2 * sin(item.rotation),
      y: item.y + resize / 2 * cos(item.rotation) - resize / 2,
      width: item.width,
      height: item.height + resize
    };
    const newItem = {...item, ...newAttrs};
    changeItem(newItem);
  }
  const resizeItemRight = (data: DraggableData, item: CardTemplateAttributeDb | CardTemplateShapeDb | CardAttributeDb | CardShapeDb, id: string) => {
    const origin = getHandlePosition(item, 'right');
    const drop = { x: data.x, y: data.y };
    const drag = { x: drop.x - origin.x, y: drop.y - origin.y };
    const dragAngle = getDragHorizontalAngle(drag.x, drag.y);
    const dragValue = sin(dragAngle) === 0 ? Math.abs(drag.x / cos(dragAngle)) : Math.abs(drag.y / sin(dragAngle));
    let resize = dragValue * cos(item.rotation - dragAngle);
    if (!isImage(item) && item.width + resize < 0) resize = -item.width;

    let newAttrs = {
      x: item.x + resize / 2 * cos(item.rotation) - resize / 2,
      y: item.y + resize / 2 * sin(item.rotation),
      width: item.width + resize,
      height: item.height
    };
    const newItem = {...item, ...newAttrs};
    changeItem(newItem);
  }
  const resizeItemRightBottom = (data: DraggableData, item: CardTemplateAttributeDb | CardTemplateShapeDb | CardAttributeDb | CardShapeDb, id: string) => {
    const origin = getHandlePosition(item, 'rightBottom');
    const drop = { x: data.x, y: data.y };
    const drag = { x: drop.x - origin.x, y: drop.y - origin.y };
    const resize = { width: drag.x * cos(item.rotation) + drag.y * sin(item.rotation), height: drag.x * -sin(item.rotation) + drag.y * cos(item.rotation) }
    if (!isImage(item) && item.width + resize.width < 0) resize.width = -item.width;
    if (item.height + resize.height < 0) resize.height = -item.height;

    let newAttrs = {
      x: item.x + resize.width / 2 * cos(item.rotation) - resize.height / 2 * sin(item.rotation) - resize.width / 2,
      y: item.y + resize.width / 2 * sin(item.rotation) + resize.height / 2 * cos(item.rotation) - resize.height / 2,
      width: item.width + resize.width,
      height: item.height + resize.height
    };
    if (isImage(item) && item.width * (item.width + resize.width) <= 0) document.body.style.cursor = getCursor({...item, width: item.width + resize.width}, 'rightBottom');
    const newItem = {...item, ...newAttrs};
    changeItem(newItem);
  }
  // いずれ実装することになった時用
  // const resizeItemTop = (data: DraggableData, item: CardTemplateAttributeDb | CardTemplateShapeDb | CardAttributeDb | CardShapeDb, id: string) => {
  //   const origin = getHandlePosition(item, 'top');
  //   const drop = { x: data.x, y: data.y };
  //   const drag = { x: drop.x - origin.x, y: drop.y - origin.y };
  //   const dragAngle = getDragVerticalAngle(drag.x, -drag.y);
  //   const dragValue = cos(dragAngle) === 0 ? Math.abs(drag.x / sin(dragAngle)) : Math.abs(drag.y / cos(dragAngle));
  //   let resize = dragValue * cos(item.rotation - dragAngle);
  //   if (item.height + resize < 0) resize = -item.height;

  //   const newAttrs = { x: item.x - resize / 2 * sin(item.rotation + 180), y: item.y + resize / 2 * cos(item.rotation + 180) - resize / 2, width: item.width, height: item.height + resize };
  //   const newItem = {...item, ...newAttrs};
  //   changeItem(newItem);
  // }
  // const resizeItemLeft = (data: DraggableData, item: CardTemplateAttributeDb | CardTemplateShapeDb | CardAttributeDb | CardShapeDb, id: string) => {
  //   const origin = getHandlePosition(item, 'left');
  //   const drop = { x: data.x, y: data.y };
  //   const drag = { x: drop.x - origin.x, y: drop.y - origin.y };
  //   const dragAngle = getDragHorizontalAngle(-drag.x, -drag.y);
  //   const dragValue = sin(dragAngle) === 0 ? Math.abs(drag.x / cos(dragAngle)) : Math.abs(drag.y / sin(dragAngle));
  //   let resize = dragValue * cos(item.rotation - dragAngle);
  //   if (item.width + resize < 0) resize = -item.width;

  //   const newAttrs = { x: item.x - resize / 2 * cos(item.rotation) - resize / 2, y: item.y - resize / 2 * sin(item.rotation), width: item.width + resize, height: item.height };
  //   const newItem = {...item, ...newAttrs};
  //   changeItem(newItem);
  // }

  return (
    <ResizeBoxSvg width={Math.abs(item.width)} height={item.height}
      x={item.x} y={item.y} rotation={item.rotation} imageWidth={isImage(item) ? item.width : undefined}
      xmlns="http://www.w3.org/2000/svg">
      { (isShape(item) || (item.cardAttributeModel !== 'multi' && item.cardAttributeModel !== 'table')) &&
        <Draggable position={getHandlePosition(item, 'leftTop')} scale={scaleValue}
          onDrag={(ev: DraggableEvent, data: DraggableData) => rotateItem(data, item, id)}
        >
          <RotationHandleCircle cx="0" cy="0" r="2" fill="white" stroke="black" strokeWidth="1"
            translateValue={{x: item.width >= 0 ? 0 : Math.abs(item.width), y: 0}} />
        </Draggable>
      }
      <Draggable position={getHandlePosition(item, 'bottom')} scale={scaleValue}
        onStart={() => {document.body.style.cursor = getCursor(item, 'bottom')}}
        onDrag={(ev: DraggableEvent, data: DraggableData) => resizeItemBottom(data, item, id)}
        onStop={() => {document.body.style.cursor = 'auto'}}
      >
        <ResizeHandleRect width={4} height={4} fill="white" stroke="black" strokeWidth="1"
          cursor={getCursor(item, 'bottom')}
          translateValue={{x: item.width >= 0 ? item.width / 2 - 1.5 : Math.abs(item.width) / 2 - 2.5, y: item.height - 1.5}} />
      </Draggable>
      <Draggable position={getHandlePosition(item, 'right')} scale={scaleValue}
        onStart={() => {document.body.style.cursor = getCursor(item, 'right')}}
        onDrag={(ev: DraggableEvent, data: DraggableData) => resizeItemRight(data, item, id)}
        onStop={() => {document.body.style.cursor = 'auto'}}
      >
        <ResizeHandleRect width={4} height={4} fill="white" stroke="black" strokeWidth="1"
          cursor={getCursor(item, 'right')}
          translateValue={{x: item.width >= 0 ? item.width - 1.5 : -2.5, y: item.height / 2 - 1.5}} />
      </Draggable>
      <Draggable position={getHandlePosition(item, 'rightBottom')} scale={scaleValue}
        onStart={() => {document.body.style.cursor = getCursor(item, 'rightBottom')}}
        onDrag={(ev: DraggableEvent, data: DraggableData) => resizeItemRightBottom(data, item, id)}
        onStop={() => {document.body.style.cursor = 'auto'}}
      >
        <ResizeHandleRect width={4} height={4} fill="white" stroke="black" strokeWidth="1"
          cursor={getCursor(item, 'rightBottom')}
          translateValue={{x: item.width >= 0 ? item.width - 1.5 : -2.5, y: item.height - 1.5}} />
      </Draggable>
      {/* <Draggable position={getHandlePosition(item, 'top')} scale={scaleValue}
        onStop={(ev: DraggableEvent, data: DraggableData) => resizeItemTop(data, item, id)}
        onDrag={(ev: DraggableEvent, data: DraggableData) => resizeItemTop(data, item, id)}
      >
        <ResizeHandleRect width={4} height={4} fill="white" stroke="black" strokeWidth="1"
          translateValue={{x: item.width / 2 - 1.5, y: -1.5}} />
      </Draggable>
      <Draggable position={getHandlePosition(item, 'left')} scale={scaleValue}
          onStop={(ev: DraggableEvent, data: DraggableData) => resizeItemLeft(data, item, id)}
          onDrag={(ev: DraggableEvent, data: DraggableData) => resizeItemLeft(data, item, id)}
      >
        <ResizeHandleRect width={4} height={4} fill="white" stroke="black" strokeWidth="1"
          translateValue={{x: -1.5, y: item.height / 2 - 1.5}} />
      </Draggable> */}
    </ResizeBoxSvg>
  );
}

type RenderImageProps = {
  item: ImageAttributeTemplate | ImageAttribute | CardTemplateImageShape | CardImageShape;
  scaleValue: number;
  id: string;
  selectingId: string | undefined;
  setSelectingId: (id: string) => void;
  dragItem: (data: DraggableData, item: ImageAttributeTemplate | ImageAttribute | CardTemplateImageShape | CardImageShape, id: string) => void;
}
const RenderImage: React.FC<RenderImageProps> = ({item, scaleValue, id, selectingId, setSelectingId, dragItem}) => {
  const imageData = isShape(item) ? item.image : item.defaultImage;
  const dataUrl = useImageData(imageData.imageId);
  const imgWidth = imageData.originWidth;
  const imgHeight = imageData.originHeight;
  const trimRatioWidth = Math.abs(item.width) / (imageData.trimXTo - imageData.trimXFrom);
  const trimRatioHeight = item.height / (imageData.trimYTo - imageData.trimYFrom);
  const translateX = -imageData.trimXFrom * trimRatioWidth;
  const translateY = -imageData.trimYFrom * trimRatioHeight;

  return (
    <Draggable position={{x: item.x, y: item.y}}
      onStart={() => setSelectingId(id)}
      onDrag={(ev: DraggableEvent, data: DraggableData) => dragItem(data, item, id)}
      scale={scaleValue}>
      <ImageDiv x={item.x} y={item.y} selecting={selectingId === id}
        width={item.width} height={item.height} rotation={item.rotation}
        frame={item.frame} $backgroundColor={item.background.display ? item.background.color : undefined}
      >
        <AttributeImg src={dataUrl} draggable="false" x={translateX} y={translateY}
          width={imgWidth * trimRatioWidth} height={imgHeight * trimRatioHeight} />
      </ImageDiv>
    </Draggable>
  );
}

type RenderCardProps = { 
  card: CardTemplateDb | CardDb;
  attributes: EditTemplateAttributeDbHashType | CardAttributeDbHashType;
  shapes: EditTemplateShapeDbHashType | EditCardShapeDbHashType;
  selectingId: string | undefined;
  setSelectingId: (id: string | undefined) => void;
  scaleValue: number;
  workHeight: number;
  changeItem: (item: any) => void;
  changeTab: () => void;
}
const RenderCard: React.FC<RenderCardProps> = ({card, attributes, shapes, selectingId, setSelectingId, scaleValue, workHeight, changeItem, changeTab}) => {
  const items = {...attributes, ...shapes};
  const ids = Object.keys(items).filter(id => items[id]);
  ids.sort((a, b) => {
    const aValue = items[a] as CardTemplateAttributeDb | CardTemplateShapeDb | CardAttributeDb | CardShapeDb;
    const bValue = items[b] as CardTemplateAttributeDb | CardTemplateShapeDb | CardAttributeDb | CardShapeDb;
    return bValue.z - aValue.z;
  })

  const dragItem = (data: DraggableData, item: CardTemplateAttributeDb | CardTemplateShapeDb | CardAttributeDb | CardShapeDb, id: string) => {
    const newAttrs = { x: data.x, y: data.y, width: item.width, height: item.height };
    const newItem = {...item, ...newAttrs};
    changeItem(newItem);
  }

  return (
    <Box style={{height: workHeight}}>
      <CardPaper id='base' width={card.defaultWidth} height={card.defaultHeight}
        elevation={card.shadow ? 1 : 0}
        frameDisplay={card.frame.display} frameColor={card.frame.color}
        backgroundDisplay={card.background.display} backgroundColor={card.background.color}
        scaleValue={scaleValue}
      >
        { ids.map(id => {
          const item = items[id];
          if (!item) return undefined;
          if (isAttribute(item) && item.cardAttributeModel === 'single') {
            const { name, color, size, bold, italic, underline, direction, orientation, yoko, tate } = getFontData(item.font);
            return (
              <div onDoubleClick={() => changeTab()}>
                <Draggable position={{x: item.x, y: item.y}}
                  onStart={() => setSelectingId(id)}
                  onDrag={(ev: DraggableEvent, data: DraggableData) => dragItem(data, item, id)}
                  scale={scaleValue}>
                  <TextDiv x={item.x} y={item.y}
                    width={item.width} height={item.height} rotation={item.rotation}
                    frame={item.frame} $backgroundColor={item.background.display ? item.background.color : undefined}
                    selecting={selectingId === id}
                    size={size} bold={bold} color={color} italic={italic} underline={underline} name={name}
                    yoko={yoko} tate={tate} direction={direction} orientation={orientation}>
                    {item.name}
                  </TextDiv>
                </Draggable>
                <div style={{display: selectingId === id ? undefined : 'none'}}>
                  <ResizeBox id={id} item={item} scaleValue={scaleValue}
                    changeItem={changeItem} />
                </div>
              </div>
            );
          } else if (isAttribute(item) && item.cardAttributeModel === 'multi') {
            const { name, color, size, bold, italic, underline, direction, orientation, yoko, tate } = getFontData(item.font);
            return (
              <div onDoubleClick={() => changeTab()}>
                <Draggable position={{x: item.x, y: item.y}}
                  onStart={() => setSelectingId(id)}
                  onDrag={(ev: DraggableEvent, data: DraggableData) => dragItem(data, item, id)}
                  scale={scaleValue}>
                  <TextDiv x={item.x} y={item.y} width={item.width} height={item.height}
                    frame={item.frame} $backgroundColor={item.background.display ? item.background.color : undefined}
                    selecting={selectingId === id}
                    size={size} bold={bold} color={color} italic={italic} underline={underline} name={name}
                    yoko={yoko} tate={tate} direction={direction} orientation={orientation}>
                    {item.name}
                  </TextDiv>
                </Draggable>
                <div style={{display: selectingId === id ? undefined : 'none'}}>
                  <ResizeBox id={id} item={item} scaleValue={scaleValue}
                    changeItem={changeItem} />
                </div>
              </div>
            );
          } else if (isAttribute(item) && item.cardAttributeModel === 'table') {
            const { name, color, size, bold, italic, yoko } = item.font;
            const columnIds = Object.keys(item.columnNames);
            const columnNames = columnIds.map(id => item.columnNames[id]);
            return (
              <div onDoubleClick={() => changeTab()}>
                <Draggable position={{x: item.x, y: item.y}}
                  onStart={() => setSelectingId(id)}
                  onDrag={(ev: DraggableEvent, data: DraggableData) => dragItem(data, item, id)}
                  scale={scaleValue}>
                  <TableDiv width={item.width} height={item.height} selecting={selectingId === id}>
                    <TableAttributeNameDiv fSize={6} bold={bold} color={color} italic={italic} name={name}>
                      {item.name}
                    </TableAttributeNameDiv>
                    <TableContainer>
                      <Table stickyHeader size="small" aria-label='sticky table'>
                        <TableHead>
                          <TableRow>
                            { columnNames.map(columnName => (
                              <AttributeTableCell fSize={size} bold={bold} color={color} italic={italic} name={name}
                                yoko={yoko}>
                                {columnName}
                              </AttributeTableCell>
                            )) }
                          </TableRow>
                        </TableHead>
                      </Table>
                    </TableContainer>
                  </TableDiv>
                </Draggable>
                <div style={{display: selectingId === id ? undefined : 'none'}}>
                  <ResizeBox id={id} item={item} scaleValue={scaleValue}
                    changeItem={changeItem} />
                </div>
              </div>
            );
          } else if (isAttribute(item) && item.cardAttributeModel === 'image') {
            return (
              <div onDoubleClick={() => changeTab()}>
                <RenderImage item={item} scaleValue={scaleValue}
                  id={id} selectingId={selectingId}
                  setSelectingId={setSelectingId} dragItem={dragItem} />
                <div style={{display: selectingId === id ? undefined : 'none'}}>
                  <ResizeBox id={id} item={item} scaleValue={scaleValue}
                    changeItem={changeItem} />
                </div>
              </div>
            );
          } else if (isShape(item) && item.kind === 'text') {
            const { name, color, size, bold, italic, underline, direction, orientation, yoko, tate } = getFontData(item.font);
            return (
              <div onDoubleClick={() => changeTab()}>
                <Draggable position={{x: item.x, y: item.y}}
                  onStart={() => setSelectingId(id)}
                  onDrag={(ev: DraggableEvent, data: DraggableData) => dragItem(data, item, id)}
                  scale={scaleValue}>
                  <TextDiv x={item.x} y={item.y}
                    width={item.width} height={item.height} rotation={item.rotation}
                    frame={item.frame} $backgroundColor={item.background.display ? item.background.color : undefined}
                    selecting={selectingId === id}
                    size={size} bold={bold} color={color} italic={italic} underline={underline} name={name}
                    yoko={yoko} tate={tate} direction={direction} orientation={orientation}>
                    {item.text}
                  </TextDiv>
                </Draggable>
                <div style={{display: selectingId === id ? undefined : 'none'}}>
                  <ResizeBox id={id} item={item} scaleValue={scaleValue}
                    changeItem={changeItem} />
                </div>
              </div>
            );
          } else if (isShape(item) && item.kind === 'circle') {
            return (
              <div onDoubleClick={() => changeTab()}>
                <CircleShape id={id} item={item}
                  setSelectingId={setSelectingId}
                  dragItem={dragItem}
                  scaleValue={scaleValue}
                  selecting={selectingId === id} />
                <div style={{display: selectingId === id ? undefined : 'none'}}>
                  <ResizeBox id={id} item={item} scaleValue={scaleValue}
                    changeItem={changeItem} />
                </div>
              </div>
            );
          } else if (isShape(item) && item.kind === 'rectangle') {
            return (
              <div onDoubleClick={() => changeTab()}>
                <RectangleShape id={id} item={item}
                  setSelectingId={setSelectingId}
                  dragItem={dragItem}
                  scaleValue={scaleValue}
                  selecting={selectingId === id} />
                <div style={{display: selectingId === id ? undefined : 'none'}}>
                  <ResizeBox id={id} item={item} scaleValue={scaleValue}
                    changeItem={changeItem} />
                </div>
              </div>
            );
          } else if (isShape(item) && item.kind === 'balloon') {
            return (
              <div onDoubleClick={() => changeTab()}>
                <BalloonShape id={id} item={item}
                  setSelectingId={setSelectingId}
                  dragItem={dragItem}
                  scaleValue={scaleValue}
                  selecting={selectingId === id} />
                <div style={{display: selectingId === id ? undefined : 'none'}}>
                  <ResizeBox id={id} item={item} scaleValue={scaleValue}
                    changeItem={changeItem} />
                </div>
              </div>
            );
          } else if (isShape(item) && item.kind === 'image') {
            return (
              <div onDoubleClick={() => changeTab()}>
                <RenderImage item={item} scaleValue={scaleValue}
                  id={id} selectingId={selectingId}
                  setSelectingId={setSelectingId} dragItem={dragItem} />
                <div style={{display: selectingId === id ? undefined : 'none'}}>
                  <ResizeBox id={id} item={item} scaleValue={scaleValue}
                    changeItem={changeItem} />
                </div>
              </div>
            );
          } else return undefined;
        }) }
      </CardPaper>
    </Box>
  );
}

export default RenderCard;
